<template>
  <div class="left-menu">
    <el-menu
      class="el-menu-vertical-demo"
      :collapse="false"
      :default-openeds="['0']"
    >
      <el-submenu :index="String(idx)" v-for="menu, idx in menus">
        <template slot="title">
          <span>{{menu.title}}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item
            :class="{active: method === subMenu.method}"
            @click="click(subMenu, menu.type)"
            v-for="subMenu, sIdx in menu.subMenus"
          >
          {{subMenu.method}}
            <span class="sub-menu-tip">{{subMenu.name}}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import menus from '../data/apis.js'

export default {
  created () {
    this.method = this.$route.query.method
  },
  components: {
  },
  data () {
    return {
      method: '',
      menus: menus
    }
  },
  methods: {
    click (menu, type) {
      this.method = menu.method
      this.$router.push({path: '/openapi', query: {method: menu.method, type: type}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.sub-menu-tip {
  display: block;
  color: #999;
  font-size: 12px;
  position: relative;
  top: -10px;
}
.left-menu .el-submenu .el-menu-item {
  line-height: 30px;
}
.el-menu-item.active {
  background-color: #ecf5ff;
}
</style>



// WEBPACK FOOTER //
// src/components/LeftMenu.vue